const LOAD_DETAIL_JOB_INDUSTRIES           = 'LOAD_DETAIL_JOB_INDUSTRIES'
const LOAD_DETAIL_JOB_INDUSTRIES_SUCCESS   = 'LOAD_DETAIL_JOB_INDUSTRIES_SUCCESS'
const LOAD_DETAIL_JOB_INDUSTRIES_FAILED    = 'LOAD_DETAIL_JOB_INDUSTRIES_FAILED'
const UNMOUNT_DETAIL_JOB_INDUSTRIES        = 'UNMOUNT_DETAIL_JOB_INDUSTRIES'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const jobIndustriesDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_JOB_INDUSTRIES:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_JOB_INDUSTRIES_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_JOB_INDUSTRIES_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_JOB_INDUSTRIES:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default jobIndustriesDetailReducer;